import React from 'react'
import { Checkbox, Text } from '@chakra-ui/react'
import * as T from '../../../components/Table'

export const ControleIlustracaoItem = ({ item, handleCheckItem }) => {
  if (!item) return null

  return (
    <T.Tr>
      <T.Td textAlign="start" px={3}>
        {item.nome_produto}
      </T.Td>

      <T.Td>{item.numero_pedido}</T.Td>
      <T.Td>{item.qtd_ilustracao}</T.Td>
      <T.Td>{item.nome_ilustracao}</T.Td>
      <T.Td>
        <Text as="a" href={item.link_modelo} target="_blank">
          {item.modelo_arte ? item.modelo_arte : 'Sem modelo'}
        </Text>
      </T.Td>
      <T.Td>
        <Text as="a" textDecor={'underline'} href={item.layout_caricatura} target="_blank" rel="noreferrer">
          Link
        </Text>
      </T.Td>
      <T.Td>
        <Checkbox size="md" colorScheme="blue" onChange={() => handleCheckItem(item.id_solicitacao)}>
          Feito
        </Checkbox>
      </T.Td>
    </T.Tr>
  )
}
